import _ from "lodash";

import { Route, Switch } from "react-router-dom";

import routesMapped from "./routesMapped";
import type { RouteItem } from "./routesObject";



export default function Routes() {

  const routesMappedArray = routesMapped.returnRoutes();

  return (
    <Switch>
      {
        routesMappedArray.map((routeItem: RouteItem) => {
          const RouteComponent = routeItem.component;
          return (
            <Route
              key={routeItem.key}
              exact
              path={routeItem.url}>
              <RouteComponent />
            </Route>
          );
        })
      }
    </Switch>
  );
}
